<template>
  <div>
    <label class="tw-flex tw-gap-2 tw-items-start">
      <input
        class="tw-mt-1"
        type="checkbox"
        :value="value"
        :disabled="disabled"
        :required="required"
        @change="toggleCheckbox"
      />
      <span>{{ title }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    disabled: Boolean,
    required: Boolean,
    formValue: [Object, String],

    extraOptions: {
      key: String,
      onValueChange: Function,
    },
  },
  emits: ["field-unmount", "isValid"],
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    isValid() {
      return !this.required || this.value === true;
    },
  },
  watch: {
    isValid: {
      handler: function (newValue) {
        this.$emit("isValid", newValue);
      },
      immediate: true,
    },
  },
  mounted: function () {
    this.value = this.formValue;
  },
  beforeUnmount: function () {
    this.$emit("field-unmount");
  },
  methods: {
    toggleCheckbox: function (event) {
      this.value = event.target.checked;
      if (
        this.extraOptions &&
        typeof this.extraOptions.onValueChange === "function"
      ) {
        this.extraOptions.onValueChange({
          key: this.extraOptions.key,
          value: event.target.checked,
        });
      }
    },
  },
};
</script>
